import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=316ba92f&scoped=true&"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrder.vue?vue&type=style&index=0&id=316ba92f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ba92f",
  null
  
)

export default component.exports